<template>
<div class="offer_wrap">
    <div class="offer_box">
        <div class="offer_case offer_header">
            <div><img src="../assets/img/offer/Offer-logo.png" class="offer_logo"></div>
            <div><h1  class="offer_maintitle">Работайте проще - зарабатывайте больше. <br> Первый сервис с элементами МИС* и инструментом для привлечения клиентов.</h1></div>
            <div class="offer_titleaddinfo">*МИС - медицинская информационная система<br>**для начала работы необходимо минимум одно устройство (компьютер, планшет, ваш личный смартфон) с доступом в интернет</div>
	    </div>
	    
	    <div class="offer_case offer_case_t1 offer_newclients">
	        <div><h2 class="offer_h2">Подключившись, вы получаете</h2></div>
	        <div class="offer_content">
	            <div class="offer_left"><img src="../assets/img/offer/Offer-carddoc.png"></div>
	            <div class="offer_right">
	                <div><h3 class="offer_h3">Новых клиентов</h3></div>
	                <div class="offer_descr">Тысячи потенциальных клиентов в вашем городе увидят вас (ваших врачей) в первых рядах списка специалистов с возможностью моментальной записи на прием</div>
	            </div>
	        </div>
	    </div>
	    
	    <div class="offer_case offer_case_t2 offer_smartagenda">
	        <div class="offer_content">
                <div class="offer_right"><img src="../assets/img/offer/Offer-agenda.png"></div>
	            <div class="offer_left">
	                <div><h3 class="offer_h3">Умную электронную регистратуру</h3></div>
	                <div class="offer_descr">(на ПК, в планшете и телефоне) 
	                    <ul class="offer_agendalist">
	                        <li>Гибкая настройка графика каждому сотруднику;</li>
	                        <li>Контроль загрузки и эффективности работы;</li>
	                        <li>Система уведомлений о новых событиях;</li>
	                        <li>Возможность автоматизации (полной или частичной) взаимодействий с клиентами на этапе записи</li>
	                    </ul>
	               </div>
	            </div>
	        </div>
	    </div>
	    
	    <div class="offer_case offer_case_t1 offer_reputation">
	        <div class="offer_content">
	            <div class="offer_left"><img src="../assets/img/offer/Offer-reputation.png" class="offer_stars"></div>
	            <div class="offer_right">
	                <div><h3 class="offer_h3">Инструменты управления репутацией</h3></div>
	                <div class="offer_descr">Управляйте своей репутацией. Создайте свою страницу. Получайте отзывы о работе своих сотрудников. Получайте уведомления о полученых отзывах. Давайте официальные ответы на них. Ваши благодарные пациенты всегда смогут вам в этом помочь.*</div>
	            </div>
	            <div class="offer_descr fullw">*Факт! Неизвестность вызывает дискомфорт: Клиенты предпочитают специалистов с отзывами значительно больше специалистов с неизвестной репутацией</div>
	        </div>
	        
	    </div>
	    <hr class="offer_hr">
	    <div class="offer_case offer_case_t1 offer_anotherbonuses">
	        <div class="offer_content">
                <div><h3 class="offer_h3">Личный кабинет каждому сотруднику и клиенту</h3></div>
                <div><h3 class="offer_h3">Систему управления взаимоотношениями с клиентами</h3></div>
                <div><h3 class="offer_h3">Интергацию с вашим существующим сайтом</h3></div>
                <h2 class="offer_h2">И много другое вместе с развитием проекта</h2>
            </div>
	    </div>
	    
	    <div class="offer_case offer_footer offer_header">
	        <div class="offer_descrwhite">Наша цель создать наилучший медицинский сервис, доступный каждому. <br> Каждый врач и клиники для нас прежде всего партнеры, совместно для развития проекта. <br> Присоединяйтесь к команде Скраймед сейчас - развивайся вместе с нами!</div>
	        
	    </div>
	    <div class="offer_descr offer_footerbg">Информация по телефону:<br><b>+380669343289</b><br>Заявки принимаются ежедневно с 8:00 до 21:00</div>
	       <div class="offer_footline"></div>
	    
    </div>
</div>
</template>
<script>
	export default {
		name: 'Offer'
	}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Offer.vue?2a3f0c83